import { useState } from "react";
import { jwtDecode } from "jwt-decode";
import { PAYMENT_API, PAYMENT_REDIRECT_BASE } from "../../api/apilist";
import { getMetaBrowserSignals } from "../../helpers/metaPixel";

export default function FiservCheckoutButton({
  eventId,
  quantity,
  couponcode,
  referralToken,
  name,
  email,
  phone,
  additionalInfo,
  state,
  authToken,
  installments,
  items,
  storeId,
  numberOfInstallments,
  onInitiateCheckout,
}) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  async function startCheckout() {
    setLoading(true);
    setErr(null);
    try {
      if (typeof onInitiateCheckout === "function") onInitiateCheckout();
      const { id, _id } = jwtDecode(authToken) || {};
      const userId = id || _id;

      const normalizedInstallments =
        numberOfInstallments ??
        installments?.count ??
        installments?.number ??
        installments?.installmentsCount ??
        null;
      const payload = {
        eventid: eventId,
        userId,
        referralToken,
        name,
        email,
        phone,
        items: (Array.isArray(items)
          ? items.map((it) => ({ ticketTypeId: it.ticketTypeId ?? null, quantity: Number(it.quantity) || Number(quantity) || 1 }))
          : [{ ticketTypeId: null, quantity: Number(quantity) || 1 }]),
        // Meta Conversions API match signals (fbp/fbc cookies + landing URL).
        ...getMetaBrowserSignals(),
      };
      const effectiveStoreId = storeId || installments?.storeId || installments?.storename || null;
      const effectiveInstallments = Number(normalizedInstallments || 0);
      if (effectiveStoreId) payload.storeId = String(effectiveStoreId);
      if (effectiveInstallments > 0) payload.numberOfInstallments = effectiveInstallments;

      const res = await fetch(`${PAYMENT_API}/api/payment/fiserv/connect/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken}` },
        body: JSON.stringify(payload),
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.message || "Error al iniciar el checkout");

      const href = json.info?.href || json.info?.checkoutUrl;
      if (!href) throw new Error("Checkout URL no recibido");
      const targetUrl = /^https?:\/\//i.test(href) ? href : `${PAYMENT_REDIRECT_BASE}${href}`;
      window.location.assign(targetUrl);
    } catch (e) {
      setErr(e.message || "No se pudo iniciar el checkout");
      setLoading(false);
    }
  }

  return (
    <div>
      <button disabled={loading} onClick={startCheckout}>
        {loading ? "Redirigiendo..." : "Pagar con fiserv"}
      </button>
      {err && <p style={{ color: "red" }}>{err}</p>}
    </div>
  );
}

